import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6.59 22q-.545 0-.914-.375c-.369-.375-.37-.56-.37-.929s.124-.679.37-.928q.368-.375.915-.375h7.833q2.022 0 3.515-1.304 1.493-1.303 1.493-3.259t-1.493-3.259-3.515-1.303h-8.09l2.44 2.476q.353.36.353.913 0 .555-.353.912-.353.36-.9.359-.545 0-.898-.359L2.353 9.877a1.15 1.15 0 0 1-.273-.423 1.5 1.5 0 0 1-.08-.49q0-.261.08-.489.081-.228.273-.424l4.623-4.693q.351-.357.899-.358c.548-.001.663.12.899.358q.353.36.353.913 0 .555-.353.913L6.334 7.66h8.09q3.114 0 5.345 2.054T22 14.83c.001 3.063-.744 3.748-2.231 5.117Q17.536 22 14.424 22z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }